export enum ListElementType {
    Group = 'Group',
    CanvasElement = 'CanvasElement',
    PageEps = 'PageEps'
}
